import React from "react";
import { AlertTriangle, Ban } from "lucide-react";

interface SuspendUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: any;
  onConfirmSuspend: () => void;
  isLoading: boolean;
}

const SuspendUserModal: React.FC<SuspendUserModalProps> = ({
  isOpen,
  onClose,
  user,
  onConfirmSuspend,
  isLoading,
}) => {
  if (!isOpen || !user) return null;

  const isSuspending = !user.isSuspended;
  const actionText = isSuspending ? "Suspend" : "Unsuspend";
  const actionIcon = isSuspending ? Ban : AlertTriangle;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-center mb-4">
          {React.createElement(actionIcon, {
            className: `h-10 w-10 ${
              isSuspending ? "text-orange-500" : "text-green-500"
            }`,
          })}
        </div>

        <h3 className="text-lg font-medium text-gray-900 text-center mb-2">
          {actionText} User
        </h3>

        <p className="text-sm text-gray-500 text-center mb-6">
          {isSuspending ? (
            <>
              Are you sure you want to suspend user "
              <span className="font-semibold">{user.fullName}</span>"? They will
              not be able to access the platform.
            </>
          ) : (
            <>
              Are you sure you want to unsuspend user "
              <span className="font-semibold">{user.fullName}</span>"? They will
              regain access to the platform.
            </>
          )}
        </p>

        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirmSuspend}
            disabled={isLoading}
            className={`px-4 py-2 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
              isSuspending
                ? "bg-orange-600 hover:bg-orange-700"
                : "bg-green-600 hover:bg-green-700"
            }`}
          >
            {isLoading ? `${actionText}ing...` : actionText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuspendUserModal;
